export default "__VITE_ASSET__67fc4561__"